import { getCookie } from './get-cookie';

export function getBigIntId(): string | undefined {
  const id = getCookie('__ivc');
  return id.length > 0 ? id : undefined;
}
